import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Route-level code splitting: each subdomain's funnel only downloads its own
// page chunk instead of one bundle containing every page. Keeps the event/
// booking/knowing/group landing pages lean for ad traffic.
const Home = lazy(() => import('./pages/Home'));
const ThankYou = lazy(() => import('./pages/ThankYou'));
const BookPage = lazy(() => import('./pages/BookPage'));
const GroupReading = lazy(() => import('./pages/GroupReading'));
const GroupThankYou = lazy(() => import('./pages/GroupThankYou'));
const EventLive = lazy(() => import('./pages/event/EventLive'));
const EventInPerson = lazy(() => import('./pages/event/EventInPerson'));
const EventThankYou = lazy(() => import('./pages/event/EventThankYou'));
const KnowingPage = lazy(() => import('./pages/knowing/KnowingPage'));
const KnowingThankYou = lazy(() => import('./pages/knowing/KnowingThankYou'));
const EnergyClearing = lazy(() => import('./pages/energy/EnergyClearing'));
const EnergyBookPage = lazy(() => import('./pages/energy/EnergyBookPage'));
const HubPage = lazy(() => import('./pages/hub/HubPage'));

// Each marketing subdomain serves its own funnel at "/" from the same SPA build.
const HOST = typeof window !== 'undefined' ? window.location.hostname : '';
const EVENT_HOST = /(^|\.)event\.soulfulevolution\.com$/i.test(HOST);
const KNOWING_HOST = /(^|\.)knowing\.soulfulevolution\.com$/i.test(HOST);
// link-in-bio "everything hub" served at offers.soulfulevolution.com (or /hub, /links)
const HUB_HOST = /(^|\.)(offers|link|hub|links)\.soulfulevolution\.com$/i.test(HOST);
// in-person Sept event: inperson./attend. subdomain, or the /inperson path on any host
const INPERSON_HOST = /(^|\.)(inperson|in-person|attend)\.soulfulevolution\.com$/i.test(HOST);
const rootEl = INPERSON_HOST ? <EventInPerson /> : HUB_HOST ? <HubPage /> : KNOWING_HOST ? <KnowingPage /> : EVENT_HOST ? <EventLive /> : <Home />;
const thankEl = KNOWING_HOST ? <KnowingThankYou /> : EVENT_HOST ? <EventThankYou /> : <ThankYou />;

// Solid-color placeholder matching each funnel's background so the (sub-200ms,
// HTTP/2) lazy-chunk fetch never flashes a wrong color before the page paints.
const FALLBACK_BG = KNOWING_HOST ? '#f7f3ec' : (EVENT_HOST || HUB_HOST) ? '#070313' : '#0b0414';
const Fallback = <div style={{ minHeight: '100vh', background: FALLBACK_BG }} aria-hidden="true" />;

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={Fallback}>
        <Routes>
          <Route path="/" element={rootEl} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/book/:tier" element={<BookPage />} />
          <Route path="/group" element={<GroupReading />} />
          <Route path="/group/thank-you" element={<GroupThankYou />} />
          <Route path="/live" element={<EventLive />} />
          <Route path="/event" element={<EventLive />} />
          <Route path="/inperson" element={<EventInPerson />} />
          <Route path="/in-person" element={<EventInPerson />} />
          <Route path="/live/in-person" element={<EventInPerson />} />
          <Route path="/live/thank-you" element={<EventThankYou />} />
          <Route path="/event/thank-you" element={<EventThankYou />} />
          <Route path="/knowing" element={<KnowingPage />} />
          <Route path="/knowing/thank-you" element={<KnowingThankYou />} />
          <Route path="/energy-clearing" element={<EnergyClearing />} />
          <Route path="/energy-clearing/book" element={<EnergyBookPage />} />
          <Route path="/hub" element={<HubPage />} />
          <Route path="/links" element={<HubPage />} />
          <Route path="/thank-you" element={thankEl} />
          <Route path="/thank-you/:tier" element={<ThankYou />} />
          <Route path="*" element={rootEl} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
